import NuvoSession from 'core/dynamicImport/NuvoSession';
import NuvoSessionListener from 'core/dynamicImport/NuvoSessionListener';

export const nuvoSessionListener = new NuvoSessionListener();

export const nuvoSession = new NuvoSession(nuvoSessionListener);
